import { AxiosInstance } from "axios";

export class OrganizationsApi {
  constructor(private axios: AxiosInstance) {}

  async submitContactForm(data: {
    name: string;
    company: string;
    email: string;
    phone: string;
    source?: string;
  }): Promise<void> {
    await this.axios.post("/api/organizations/contact", data);
  }
}
